import Icon from '../components/Icon.vue'

Icon.register({"stop":{"width":1536,"height":1792,"paths":[{"d":"M1536 192v1408q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h1408q26 0 45 19t19 45z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/stop.js